import React from "react";

// Sigma (Σ) Icon
export const SigmaIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <text
      x="12"
      y="16"
      textAnchor="middle"
      fontSize="16"
      fontFamily="Arial"
    >
      Σ
    </text>
  </svg>
);

// Exclamation Triangle Icon
export const ExclaimIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M9.401 3.062a.75.75 0 0 1 1.198 0l8.82 11.051c.553.693.087 1.687-.599 1.687H1.18c-.686 0-1.152-.994-.6-1.687L9.4 3.062zM12 9a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5A.75.75 0 0 0 12 9zm0 7a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75z"
      clipRule="evenodd"
    />
  </svg>
);

// Pickup Icon (Arrow Down Tray)
export const PickupIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5" />
    <path d="M12 3v12" />
    <path d="M8.25 12.75l3.75 3.75 3.75-3.75" />
  </svg>
);

// Truck Icon
export const TruckIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zm-7-7h11v5h-1.6a3.001 3.001 0 00-5.8 0H5a2 2 0 00-2 2v3h2v-3h1a.55.55 0 00.1 0h3.2a3.001 3.001 0 005.8 0H17v-5l-3-5H2v5zm13 0v5h3l1.5-2.5L15 10z" />
  </svg>
);

// Check Circle Icon
export const CheckIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M2.25 12a9.75 9.75 0 1119.5 0 9.75 9.75 0 01-19.5 0zM17.03 8.97a.75.75 0 00-1.06-1.06l-4.47 4.47-1.97-1.97a.75.75 0 10-1.06 1.06l2.5 2.5c.3.3.77.3 1.06 0l5-5z"
      clipRule="evenodd"
    />
  </svg>
);

// Reverse Icon (Arrow Left-Right)
export const ReverseIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 12h18M3 12l4-4m-4 4l4 4M21 12l-4-4m4 4l-4 4" />
  </svg>
);

// Confirmation Icon (Clock with Checkmark)
export const ConfirmationIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

// Unprocessed Icon (Warning Clock - orders stuck in processing)
export const UnprocessedIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
    <path d="M4 4l16 16" strokeWidth={2.5} />
  </svg>
);

// Loader (Spinner) Icon
export const Loader = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    fill="none"
    stroke="currentColor"
    strokeWidth="4"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Background circle (faded) */}
    <circle
      cx="25"
      cy="25"
      r="20"
      className="opacity-25"
    />
    {/* Foreground arc (opaque) */}
    <circle
      cx="25"
      cy="25"
      r="20"
      strokeDasharray="31.415, 31.415"
      strokeDashoffset="0"
      className="opacity-75"
    />
  </svg>
);